import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import { GetCoockie, ValidateQty, FormatCurrency, DefaultImage, KImageURL, SearchContent, CheckSession, PrintDocument } from "../GlobalScript";
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useReactToPrint } from 'react-to-print';
import PrintableOrder from './order/PrintableOrder.js';

const HistoryDetail = ({ show, handleClose, order, historyType, userInfo, exchange}) => {

    const [isPrinting, setIsPrinting] = useState(false);
    const contentRef = useRef(null);
    const promiseResolveRef = useRef(null);
    const [CreditRequest, setCreditRequest] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    //const [CRDocument, setCRDocument] = useState(null);

    useEffect(() => {
        if (isPrinting && promiseResolveRef.current) {
            promiseResolveRef.current();
        }
    }, [isPrinting]);

    useEffect(() => {
        if (historyType === 'credit' && order && order.orderDetail) {
            const map = new Map();
            order.orderDetail.items.forEach((data) => {
                const groupKey = data.invoice;
                if (map.has(groupKey)) {
                    const temp = map.get(groupKey);
                    temp.set(data.sku, data);
                } else {
                    const temp = new Map();
                    temp.set(data.sku, data);
                    map.set(groupKey, temp)
                }
            });
            setCreditRequest(map);
        }
    }, [order]);

    const modalBody = document.querySelector('.modal-body');
    const tracking = document.getElementById('trackingSection');
    const orderDetails = document.getElementById('orderDetailsSection');

    const goToOrderDetails = () => {
        const top = orderDetails.getBoundingClientRect().top - modalBody.getBoundingClientRect().top + modalBody.scrollTop;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                modalBody.scrollTo({
                    top,
                    behavior: 'smooth'
                });
            });
        });
    }

    const goToTracking = () => {
        const top = tracking.getBoundingClientRect().top - modalBody.getBoundingClientRect().top + modalBody.scrollTop;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                modalBody.scrollTo({
                    top,
                    behavior: 'smooth'
                });
            });
        });
    }

    const trackingLookup =
        order?.orderDetail?.trackings?.reduce((acc, tracking) => {
            acc[tracking.sku] = tracking;
            return acc;
        }, {}) || {};

    //const handlePrint = useReactToPrint({
    //    contentRef,
    //    onBeforeGetContent: () => {
    //        return new Promise((resolve) => {
    //            promiseResolveRef.current = resolve;
    //            setIsPrinting(true);
    //        });
    //    },
    //    onAfterPrint: () => {
    //        promiseResolveRef.current = null;
    //        setIsPrinting(false);
    //    }
    //});

    const handlePrint = (crNum) => {
        if (crNum) {
            PrintDocument(crNum);
        }
    }    

    const AddressBlock = (data) => {
        return <>
            <p className="mb-0">{data.firstName}</p>
            <p className="mb-0">{data.address} {data.city}</p>
            <p className="mb-0">{data.stateCode} {data.zipCode}</p>
            <p className="mb-0">{data.countryCode}</p></>
    }

    const handlePrintOrder = useReactToPrint({
        contentRef,
        onBeforeGetContent: () => {
            return new Promise((resolve, reject) => {
                if (!contentRef.current) {
                    reject(new Error('There is nothing to print'));
                } else {
                    promiseResolveRef.current = resolve;
                    setIsPrinting(true);
                }
            });
        },
        onAfterPrint: () => {
            promiseResolveRef.current = null;
            setIsPrinting(false);
        },
        onPrintError: (errorLocation, error) => {
            console.error('Print error at:', errorLocation, error);
            setTimeout(() => {
            }, 0);
        }
    });

    const tryPrintOrder = () => {
        if (order.orderDetail.items.length === 0) {
            setErrorMsg(
                'There was an error while attempting to print your cart. Please try again later.'
            );
        } else {
            handlePrintOrder();
        }
    }

    if (!order) return null;

    return (
        <Modal show={show} onHide={handleClose} scrollable size="lg" dialogClassName="modal-90w dealer-section item-inquiry-modal">
            <style type="text/css" media="print">
                {"\
                @page { size: portrait; margin: 0.5in; }\
                "}
            </style>

            <div style={{ display: 'none' }}>
                <PrintableOrder
                    ref={contentRef}
                    orderItems={order.orderDetail.items}
                    orderName={order.order.orderName}
                    orderDate={order.order.orderDate}
                    orderType={order.orderDetail.orderType}
                    orderBy={order.order.orderByName}
                    kCode={order.orderDetail.kCode}
                    shipTo={order.orderDetail.shipTo}
                    shipMethod={order.orderDetail.shipMethod}
                    partsTotal={order.orderDetail.partsSubtotal}
                    accTotal={order.orderDetail.accSubtotal}
                    otherTotal={order.orderDetail.otherSubtotal}
                    estFreight={order.orderDetail.estFreight}
                    estHandling={order.orderDetail.estHandling}
                    estSpecialFee={order.orderDetail.estSpecialFee}
                    grandTotal={order.order.total}
                    orderID={order.order.orderID}
                    tracking={order.orderDetail}
                />
            </div>

            <Modal.Header closeButton>
                <Row className="w-100w">
                    <Col sm={12}>
                        <Modal.Title className="text-left">{historyType === 'order' ? 'ORDER DETAIL' : 'CREDIT REQUEST DETAILS'}</Modal.Title>
                    </Col>
                </Row>

                <CloseButton variant="white" data-bs-theme="dark" className="btn-close-sibling" />

            </Modal.Header>

            {historyType === 'order' &&
                <Modal.Header className="modal-header-default">
                    <Row>
                        <Col sm={12}>
                            <div className="default-row text-left">
                                <div>
                                    <p className="bold underline mb-0" onClick={() => goToOrderDetails()}>
                                        <span className="svg-holder small-svg">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 484 385.3">
                                                <g>
                                                    <rect className="st2" x="113.2" y="5.2" width="284.3" height="380.2" rx="37.2" ry="37.2" />
                                                    <line className="st12 st14" x1="139.1" y1="64.8" x2="238.5" y2="64.8" />
                                                    <line className="st12 st14" x1="260.9" y1="215.1" x2="360.3" y2="215.1" />
                                                    <line className="st14 st15" x1="139.1" y1="97.6" x2="360.3" y2="97.6" />
                                                    <line className="st14 st15" x1="139.1" y1="130.5" x2="360.3" y2="130.5" />
                                                    <line className="st14 st15" x1="139.1" y1="169.3" x2="360.3" y2="169.3" />
                                                    <line className="st14 st15" x1="144.7" y1="273.9" x2="365.9" y2="273.9" />
                                                    <line className="st14 st15" x1="144.7" y1="312.8" x2="365.9" y2="312.8" />
                                                </g>
                                            </svg>

                                            ORDER DETAILS
                                        </span>
                                    </p>
                                    {errorMsg &&
                                        <p className="red">{errorMsg}</p>
                                    }
                                </div>

                                <div className="ml-4">
                                    <p className="bold underline mb-0" onClick={() => goToTracking()}>
                                        <span className="svg-holder small-svg">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 484 382">
                                                <g>
                                                    <polygon className="st2" points="228.7 57.6 192.4 37.4 62.5 111.4 99.3 133.9 228.7 57.6" />
                                                    <polygon className="st2" points="55.3 122.4 92.7 144.9 92.7 213.4 151.8 248 155.5 180.3 185.5 197.8 185.5 346.7 55.3 272.1 55.3 122.4" />
                                                    <path d="M104.5,144.3l135.9-78,12.7,6.9s-3.2,16.4-2.3,20.4-108.3,65.7-108.3,65.7l.6,70.8-38.6-21.9v-63.9Z" />
                                                    <path className="st2" d="M266.4,143.1l-74,42.6-38.9-21.3,98.5-56.7c.6,7.5,12.1,31.4,14.4,35.4Z" />
                                                    <path className="st2" d="M271.6,152.3l-73.7,44.7v149.7l61.6-33.9,13.8-27c-22.8-7.5-44.6-81.8,6.9-120.4-2.6-3.2-8.6-13.1-8.6-13.1Z" />
                                                    <path className="st2" d="M334.5,21.6c-44.7-.7-77.6,36.8-71.2,82.1,1.1,7.5,3.6,14.7,7.4,21.3,13.3,23.5,53.9,95.3,63.8,111.6,0,0,43.8-69.1,66-114.2,22.3-45.1-13.1-99.6-66-100.8ZM334.9,133.9c-22.6,0-40.8-18.3-40.8-40.8s18.3-40.8,40.8-40.8,40.8,18.3,40.8,40.8-18.3,40.8-40.8,40.8Z" />
                                                    <path d="M286.1,179c-23,18.8-37.5,76,8,107.5-4.1,6.9-11.8,21.1-11.8,21.1l-4.6-1.9-22.7,39.2c-4.6,9.6,8.1,25.3,21.1,12.7,5.4-9.6,23.8-38.8,23.8-38.8l-5.9-2.7,12.8-20.7c63.4,19.2,128.6-44.2,77.6-116.4-5,5-11.1,16.1-11.1,16.1,20.4,32.3,14.6,86.8-43.8,86-28.8-1.2-62.8-38.4-35.4-86.4-2.2-4.2-8-15.7-8-15.7Z" />
                                                </g>
                                            </svg>

                                            TRACKING
                                        </span>
                                    </p>
                                    {errorMsg &&
                                        <p className="red">{errorMsg}</p>
                                    }
                                </div>

                                <div>
                                    <p className="bold underline mb-0" id="btnPrint" onClick={() => tryPrintOrder(order.order.orderID)}>
                                        <span className="svg-holder small-svg">
                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 732.3 453.2">
                                                <g>
                                                    <polyline className="st12 st14" points="398.6 139.6 398.6 53.8 564.5 53.8 603.1 89.5 603.1 139.6" />
                                                    <polyline className="st13 st14" points="564.5 53.8 564.5 87.8 600.2 87.8" />
                                                    <rect className="st10 st16 st17" x="337" y="139.6" width="322.6" height="156.7" rx="16.7" ry="16.7" />
                                                    <rect className="st13 st14" x="377.3" y="238.7" width="241.3" height="35.1" rx="9.5" ry="9.5" />
                                                    <rect className="st12 st14" x="398.6" y="257.7" width="201.6" height="182.6" />
                                                    <rect className="st2" x="363.5" y="155.7" width="28.2" height="5.8" />
                                                    <rect className="st2" x="339.3" y="209.3" width="320.3" height="11.5" />
                                                    <rect className="st2" x="399.7" y="155.7" width="11.8" height="5.8" />
                                                </g>
                                            </svg>

                                            PRINT ORDER
                                        </span>
                                    </p>
                                    {errorMsg &&
                                        <p className="red">{errorMsg}</p>
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Header>
            }

            <Modal.Body {...(historyType === 'credit' ? { ref: contentRef } : {})}>
                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row id="orderDetailsSection">
                                    {order && order.order && order.orderDetail &&
                                        <>
                                            <Col sm={3} className="text-left">
                                                <p className="bold">Order Information</p>

                                                {/*<p className="mb-0">Reference #: {order.order.refID}</p>*/}
                                                {historyType === 'order' ?
                                                    <>
                                                        {order.order.orderID && <p className="mb-0">Order #: {order.order.orderID}</p>}
                                                        {order.order.orderName && <p className="mb-0">Order Name: {order.order.orderName}</p>}
                                                        <p className="mb-0">Order Date: {order.order.orderDate}</p>
                                                        <p className="mb-0">Order Type: {order.orderDetail.orderType}</p>
                                                        <p className="mb-0">Ordered By: {order.order.orderByName}</p>

                                                        {order.order.dealer === true &&
                                                            <>
                                                                <p className="mb-0">KCode: {order.orderDetail.kCode}</p>
                                                                <p className="mb-0">Exchange Order: {order.orderDetail.exchangeOrder ? 'Yes' : 'No'}</p>
                                                            </>
                                                        }                                                    
                                                    </>
                                                    :
                                                    <>
                                                        {order.order.orderID && <p className="mb-0">Confirmation #: {order.order.orderID}</p>}
                                                        <p className="mb-0">Request Date: {order.order.orderDate}</p>
                                                        <p className="mb-0">Requested By: {order.order.orderByName}</p>
                                                    </>
                                                }
                                            </Col>
                                        
                                            <Col sm={3} className="text-left">
                                                <p className="bold">{historyType === 'order' ? 'Shipping Information' : 'Dealer Information'}</p>
                                                {order.orderDetail.shipTo && order.orderDetail.shipTo.countryCode === '' && <p className="mb-0 bold">Dropship Address:</p>}
                                                {order.orderDetail.shipTo && AddressBlock(order.orderDetail.shipTo)}
                                                {order.orderDetail.forwarderTo && <p className="mb-0 mt-2 bold">Forwarder Address:</p>}
                                                {order.orderDetail.forwarderTo &&
                                                    AddressBlock(order.orderDetail.forwarderTo)
                                                }
                                            </Col>

                                            {historyType === 'credit' && order.order.orderID && order.order.status === "Submitted" &&
                                                <Col sm={3} className="text-left">
                                                    <p className="bold underline" id="btnPrint" onClick={()=>handlePrint(order.order.orderID)}>
                                                        <span className="svg-holder small-svg" style={{ display: 'flex' }}>
                                                            <img src="../../../Images/printer-icon.svg" alt="Print" style={{ height: '40px', marginTop: '-8px' }} />
                                                            Print Documents
                                                        </span>
                                                    </p>
                                                </Col>
                                            }

                                        </>
                                    }
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} className="order-table">
                        <Card>
                            <Card.Body>
                                <Row className="table-legend">
                                    <Col sm={12}>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>
                                            <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>
                                            <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>
                                        </div>
                                        <div className="table-legend-section">
                                            {userInfo?.loginType === 5 &&
                                                <>
                                                    <span className="svg-holder"><img src="../../../Images/Allocated.svg" alt="" className="" />Allocated</span>
                                                    <span className="svg-holder"><img src="../../../Images/AllocationProcessing.svg" alt="" className="" />Allocation Processing</span>
                                                </>
                                            }
                                            <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>
                                            <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>
                                            {userInfo?.loginType !== 5 &&
                                                <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>
                                            }
                                            {historyType === 'order' &&
                                                <span className="svg-holder"><img src="../../../Images/Allocated.svg" alt="" className="" /> Allocated</span>
                                            }
                                            <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>
                                            <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                        </div>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        {historyType === 'order' &&
                            <Table hover responsive className="compact-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        {/*<th>PRODUCT <br /> IMAGE</th>*/}
                                        <th width={"25%"}>PRODUCT</th>
                                        {/*<th>TRACKING</th>*/}
                                        <th>MEMO</th>
                                        <th width={"5%"}>ITEM <br /> TYPE</th>
                                        <th width={"5%"}>STATUS</th>
                                        <th>QTY</th>
                                        <th>BKORD <br /> QTY</th>
                                        <th>UNIT <br /> PRICE</th>
                                        <th>SUBTOTAL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {order && order.orderDetail && order.orderDetail.items && order.orderDetail.items.map((item, index) => {
                                        const trackingInfo = trackingLookup[item.sku];

                                        return (
                                            <tr className="" key={index}>
                                                <td>{index + 1}</td>
                                                {/*<td className="table-img">*/}
                                                {/*    <img src={KImageURL(item.sku, item.img)}*/}
                                                {/*        onError={({ currentTarget }) => {*/}
                                                {/*            currentTarget.onerror = null;*/}
                                                {/*            currentTarget.src = DefaultImage;*/}
                                                {/*        }}*/}
                                                {/*        alt="Product" className="item-image"></img>*/}
                                                {/*</td>*/}
                                                <td className="table-left">
                                                    <p className="mb-0">{item.desc}</p>
                                                    <p className="mb-0">Item No: {item.sku}</p>
                                                </td>
                                                {/*<td>*/}
                                                {/*    {trackingInfo?.tracking &&*/}
                                                {/*        <>*/}
                                                {/*            {trackingInfo.tracking}*/}

                                                {/*            <p className="mb-0 underline" onClick={() => goToTracking()}>Tracking Details</p>*/}
                                                {/*        </>*/}
                                                {/*    }*/}
                                                {/*</td>*/}
                                                <td>{item.memo}</td>
                                                <td className="table-img">
                                                    <img src={"../../../Images/" + item.inventoryTypeImg} alt="item-type" className="item-type-image"></img>
                                                </td>
                                                <td className="table-img"> <span className="svg-holder"><img src={"../../../Images/" + item.statusImg} alt="" className="item-type-image" /></span></td>
                                                <td>{item.qty}</td>
                                                <td>{item.boQty}</td>
                                                <td>${item.unitPrice}</td>
                                                <td>${item.subtotal}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        }

                        {historyType === 'credit' && CreditRequest && CreditRequest.size > 0 &&
                            <Row>
                                {Array.from(CreditRequest.entries()).map(([key, valueArray]) => (
                                    <React.Fragment key={key}>
                                        {key && SearchContent(key)}
                                        <Col sm={12} className="order-table" key={"col2_" + key}>
                                            <Table hover responsive key={"tbl" + key} className="compact-table">
                                                <thead>
                                                    <tr>
                                                        {/*<th>IMAGE</th>*/}
                                                        <th width="15%">DETAILS</th>
                                                        <th>RETURN <br /> QTY</th>
                                                        <th>RECEIVED <br /> QTY</th>
                                                        <th>PRICE</th>
                                                        <th width="25%">REASON AND <br /> COMMENT</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.from(valueArray.values()).map((value, index) => (
                                                        <tr className="" key={key + value.sku}>
                                                            {/*<td className="table-img">*/}
                                                            {/*    <img src={KImageURL(value.sku, value.img)}*/}
                                                            {/*        onError={({ currentTarget }) => {*/}
                                                            {/*            currentTarget.onerror = null;*/}
                                                            {/*            currentTarget.src = DefaultImage;*/}
                                                            {/*        }}*/}
                                                            {/*        alt="Product"*/}
                                                            {/*        className="item-image">*/}
                                                            {/*    </img>*/}
                                                            {/*</td>*/}
                                                            <td className="text-left">
                                                                {exchange && value.invoice && <p className="green-text">Invoice: #{value.invoice}</p>}
                                                                <p>{value.desc}</p>
                                                                <p className="mb-0">SKU: {value.sku}</p>
                                                            </td>
                                                            <td>{value.return_qty}</td>
                                                            <td>{value.received_qty}</td>
                                                            <td>{FormatCurrency(value.unitPrice??0)}</td>
                                                            <td>
                                                                <p>{value.returnReason}</p>
                                                                <p>{value.comments}</p>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </React.Fragment>
                                ))}
                            </Row>
                        }
                    </Col>

                    {historyType === 'order' ?
                        order && order.orderDetail && <>
                            <Col xl={{ offset: 8 }} className="vertical-line mb-4 padding-extra-right text-right">
                                <Row>
                                    <Col className="text-left">
                                        <p className="mb-0">Parts Subtotal</p>
                                        <p className="mb-0">Acc Subtotal</p>
                                        <p className="mb-0">Other Subtotal</p>
                                        <p className="mb-0">Est Freight</p>
                                        <p className="mb-0">Est Handling</p>
                                        <p className="mb-0">Est Special Fee</p>
                                        <p className="mb-0">K-Code</p>
                                        <p className="mb-0 bold">Total</p>
                                    </Col>
                                    <Col className="text-right">
                                        <p className="mb-0">${order.orderDetail.partsSubtotal}</p>
                                        <p className="mb-0">${order.orderDetail.accSubtotal}</p>
                                        <p className="mb-0">${order.orderDetail.otherSubtotal}</p>
                                        <p className="mb-0">${order.orderDetail.estFreight}</p>
                                        <p className="mb-0">${order.orderDetail.estHandling}</p>
                                        <p className="mb-0">${order.orderDetail.estSpecialFee}</p>
                                        <p className="mb-0">{order.orderDetail.kCode ? order.orderDetail.kCode : "N/A"}</p>
                                        <p className="mb-0 bold">{FormatCurrency(order.order.total??0)}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </>

                        :
                        <>
                            {order && order.order &&
                                <Col sm={{ offset: 9 }} className="vertical-line mb-4">
                                    <Row>
                                        <Col className="text-left">
                                            <p className="mb-0">Credit Subtotal</p>
                                            <p className="mb-0 bold">Total</p>
                                        </Col>
                                        <Col>
                                            <p className="mb-0">${order.order.total}</p>
                                            <p className="mb-0 bold">${order.order.total}</p>
                                        </Col>
                                    </Row>
                                </Col>}
                        </>
                    }
                </Row>

                {historyType === 'order' &&
                    <Row id="trackingSection">
                        <Col sm={12} className="order-table">
                            <div className="vertical-line text-left mt-2">
                                <h4 className="bold">TRACKING</h4>
                            </div>

                            <Card>
                                <Card.Body>
                                    <Row className="table-legend">
                                        <Col sm={12}>
                                            <div className="table-legend-section">
                                                <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>
                                                <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>
                                                <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>
                                                <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>
                                                <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            <Table hover responsive className="mb-5 compact-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>PRODUCT</th>
                                        <th>STATUS</th>
                                        <th>QTY <br /> ORDERED</th>
                                        <th>QTY <br /> SHIPPED</th>
                                        <th>QTY <br /> CANCELLED</th>
                                        <th>QTY <br /> RETURNED</th>
                                        <th>QTY <br /> OWED</th>
                                        <th>INVOICE</th>
                                        <th>CARRIER</th>
                                        <th>TRACKING</th>
                                        <th>DATE <br /> SHIPPED</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {order && order.orderDetail && order.orderDetail.trackings && order.orderDetail.trackings.map((item, index) => (
                                        <tr className="" key={"tr" + index}>
                                            <td>{index + 1}</td>
                                            <td className="table-left">
                                                <p className="mb-0">{item.desc}</p>
                                                <p className="mb-0">Item No: {item.sku}</p>
                                            </td>
                                            <td></td>
                                            {/* <td>Icon</td>*/}
                                            <td>{item.qtyOrdered}</td>
                                            <td>{item.qtyShipped}</td>
                                            <td>{item.qtyCancelled}</td>
                                            <td>{item.qtyReturned}</td>

                                            <td>{item.qtyOwned}</td>
                                            {/*  <td>{item.qtyOwned}</td>*/}
                                            <td>{item.invoice}</td>
                                            <td>{item.carrier}</td>
                                            <td>
                                                {item.carrier && item.carrier !== '' && item.tracking && item.tracking !=='' ? 
                                                    <a href={item.url} target="_blank" rel="noopener noreferrer">{item.tracking}</a>
                                                :
                                                    <>{item.tracking}</>
                                                }
                                            </td>
                                            <td>{item.dateShipped}</td>
                                        </tr>
                                    ))}

                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
            </Modal.Body>

            <Modal.Footer className="black-bg">
                <Row className="w-100w">
                    <Col sm={{ offset: 10 }}>
                        <Button variant="secondary" onClick={handleClose}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            CLOSE
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>

        </Modal>
    )
}

export default HistoryDetail;